import { render, staticRenderFns } from "./PluginCode.vue?vue&type=template&id=789789a7&scoped=true&"
import script from "./PluginCode.vue?vue&type=script&lang=js&"
export * from "./PluginCode.vue?vue&type=script&lang=js&"
import style0 from "./PluginCode.vue?vue&type=style&index=0&id=789789a7&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "789789a7",
  null
  
)

export default component.exports